"use client";
import PropertyCarousel2 from "../components/PropertyCarousel2";
import EmblaCarousel from "../../design1/components/DynamicSlider";
import { planImage } from "../../design1/SalePage1";
import { utilities } from "../../design1/PropertyPage1";
import { ParentCard } from "../../design1/PropertyPage1";
import { PropertyUtilities3 } from "../../../constants/utilitiesIcons";
import { generateSliderImages } from "../components/PropertyCarousel2";
import { mockProperties } from "../../../constants/mockProperties";
import { Form } from "../../design1/components/ContactMandate";
import React from "react";
import { usePathname } from "next/navigation";
import { useSearchParams } from "next/navigation";
import Example from "../../design1/components/Map";
import { MemberType, PropertyType } from "src/types";
import Link from "next/link";
import CardGrid from "../../../CardGrid";
import { CardVariant3 } from "../../design2/components/CardVariant2";
import { useParams } from "next/navigation";
import { findPropertyById } from "../../../constants/mockProperties";
import { useState } from "react";
import { m, AnimatePresence, LazyMotion, domAnimation } from "framer-motion";
import { PropertyCard } from "../../design2/Rent2";
import StyledWraper from "../components/StyledWraper";
import Button from "src/app/components/ui/Button";
import { ShowMoreText } from "../../design1/About1";
import { mockDesc } from "../../design2/Sale2";
import { members } from "../../design1/components";
import Image from "next/image";
import { VerifiedBadge } from "src/app/components/Icon";
import { capitalizeWords } from "src/app/components/utils";
import { generateSlugWithId } from "src/app/serverUtils";

const Sale3 = () => {
  const search = useParams();
  const { id } = search;
  const toNum = parseInt(id as string);
  const property = findPropertyById(toNum)!;
  const isOutRight = !property.beforePrice;
  const images = generateSliderImages(mockProperties.forRent[0].images);
  return (
    <section>
      <div className=" pb-10 pt-5">
        <PropertyCarousel2
          images={[
            ...images,
            {
              url: "https://www.youtube.com/watch?v=m3E72ZJ54_k",
              type: "video",
            },
          ]}
        />

        {/* <div className="items mt-6 mb-4 flex items-center justify-between">
          <div className="first flex flex-col gap-3">
            <div className="if text-label-main">(Property ID:6454545)</div>
            <h1 className="text-3xl">{property.title}</h1>
            <div className="addy items-center gap-3 flex">
              <div className="address flex items-center gap-3">
                <AddressIcon />{" "}
                <AddressLink
                  className="text-label-main"
                  address="Street 23, All Avenue, Nigeria"
                />
              </div>
              <h6 className="text-themeColor">Commercial</h6>
            </div>
          </div>
          <div className="price flex flex-col items-end">
            <div className="item items-end gap-1 flex">
              <h2 className="text-themeColor leading-none w-max text-right">
                {" "}
                {property.beforePrice && (
                  <span className="text-secondary-main text-base block text-left line-through">
                    Before: ₦{property.beforePrice.toLocaleString()}
                  </span>
                )}
                ₦{property.price.toLocaleString()}
              </h2>{" "}
              {property.discount && (
                <span className="text-secondary-main">Now</span>
              )}
            </div>

            <div className="others flex gap-3">
              <span className="text-secondary-main">
                {" "}
                <span className="text-themeColor">
                  {" "}
                  ₦{property.quotePrice.toLocaleString()}
                </span>{" "}
                / {camelCaseToWords(property.priceType)}
              </span>
              {property.discount && (
                <span className="text-themeColor">
                  {property.discount} Discount on Initial Price
                </span>
              )}
            </div>
          </div>
        </div> */}

        <div className="wrapper">
          <PropertyCard
            quote={property.quote}
            variant
            title={property.title}
            price={property.price}
            propertyId="6454545"
            address={property.address}
            beforePrice={property?.beforePrice}
            discount={property.discount}
            quotePrice={property.quotePrice}
            priceType={property.priceType}
          />
          <div className="grid-container relative mt-12">
            <div className="first flex flex-col gap-4">
              {" "}
              <StyledWraper>
                <ParentCard header="Property Brief">
                  <ShowMoreText text={mockDesc} />
                </ParentCard>
              </StyledWraper>
              <StyledWraper>
                <ParentCard header="Facilities">
                  <PropertyUtilities3 selectedItems={utilities} />
                </ParentCard>
              </StyledWraper>
              {isOutRight && (
                <StyledWraper>
                  <ParentCard header="Property Information">
                    <KeyValueDisplay data={propertyDetails} />
                  </ParentCard>
                </StyledWraper>
              )}
              {!isOutRight && (
                <StyledWraper>
                  <ParentCard header="Property Information">
                    <KeyValueDisplay data={propertyDetails2} />
                  </ParentCard>
                </StyledWraper>
              )}
              {isOutRight && (
                <StyledWraper>
                  <ParentCard header="Price and Other Charges">
                    <KeyValueDisplay money data={priceDetails} />
                  </ParentCard>
                </StyledWraper>
              )}
              {!isOutRight && (
                <StyledWraper>
                  <ParentCard header="Terms & Conditions">
                    <AccordionVariant
                      data={{
                        questions: [
                          {
                            question: "Refund Policy",
                            answer: "You can request a refund within 7 days.",
                          },
                          {
                            question: "Property Facility",
                            answer: "Facilities include WiFi, Pool, and Gym.",
                          },
                          {
                            question: "Other Rules",
                            answer: "No smoking inside the premises.",
                          },
                        ],
                      }}
                    />
                  </ParentCard>
                </StyledWraper>
              )}
              {!isOutRight && (
                <StyledWraper>
                  <ParentCard header="First Deposit">
                    <KeyValueDisplay money data={firstDeposit} />
                  </ParentCard>
                </StyledWraper>
              )}
              {!isOutRight && (
                <StyledWraper>
                  <ParentCard header="Monthly Spreading">
                    <KeyValueDisplay money data={monthlySpreading} />
                  </ParentCard>
                </StyledWraper>
              )}
              {!isOutRight && (
                <StyledWraper>
                  <ParentCard header="Other Charges">
                    <KeyValueDisplay money data={otherCharges} />
                  </ParentCard>
                </StyledWraper>
              )}
              {/* {!isOutRight && (
                <StyledWraper>
                  <ParentCard header="Document">
                    <KeyValueDisplay
                      data={{ "C of O. Record Copy Survey, Agreement": "" }}
                    />
                  </ParentCard>
                </StyledWraper>
              )} */}
              <StyledWraper>
                <ParentCard header="Location">
                  <Example />
                </ParentCard>
              </StyledWraper>
              {isOutRight && (
                <StyledWraper>
                  <ParentCard header="Document">
                    <p className="mb-4">
                      C of O. Record Copy Survey, Agreement
                    </p>
                    <div className="carousel w-auto">
                      <EmblaCarousel variant slides={planImage} />
                    </div>
                  </ParentCard>
                </StyledWraper>
              )}
              {isOutRight && (
                <StyledWraper>
                  <ParentCard header="Buiding Plan">
                    <div className="carousel w-auto">
                      <EmblaCarousel variant slides={planImage} />
                    </div>
                  </ParentCard>
                </StyledWraper>
              )}
              {/* {!isOutRight && (
                <ParentCard header="Rules">
                  <PropertyUtilities3 list="rules" selectedItems={mockRules} />
                </ParentCard>
              )} */}
            </div>
            <SideItem3
              properties={mockProperties.forRent}
              members={members[0]}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
export default Sale3;

export const SideItem3: React.FC<{
  members: MemberType;
  properties?: PropertyType[];
}> = ({ members, properties }) => {
  if (!members && !properties) return null;
  return (
    <div className="second max-h-[600px] xlg:max-h-[1000000px] scrollbar-hide overflow-scroll sticky top-[80px] flex flex-col gap-8 ">
      <div className="first flex-col flex gap-5  rounded-xl">
        <StyledWraper>
          <ParentCard header="Staff Contact">
            <StaffContact2 {...members} />
          </ParentCard>
        </StyledWraper>
        <StyledWraper>
          <ParentCard header="Contact Mandate">
            <Form email={members.email} variant />
          </ParentCard>
        </StyledWraper>
      </div>
      {properties && properties.length > 0 ? (
        <StyledWraper className="second p-3 bg-white  rounded-xl">
          <div className="alal  flex items-center justify-between">
            <h5 className=" font-semibold text-secondary-main">
              Staff Listing
            </h5>
            <Button
              variant="new"
              className="text-themeColor h-max"
              href="/properties"
            >
              See More
            </Button>
          </div>
          <CardGrid className="divide-y divide-y-themeColor" maxColumns={1}>
            {properties?.map((item, index) => {
              return (
                <div key={index} className="pt-4">
                  <CardVariant3 {...item} />
                </div>
              );
            })}
          </CardGrid>
        </StyledWraper>
      ) : (
        <div>Properties not available</div>
      )}
    </div>
  );
};

interface KeyValueDisplayProps {
  data: Record<string, string | number>;
  money?: boolean;
}

const banned = ["0", 0, "None", "none", "--", "__", "₦0", "$0", "€0", "£0"];

export const KeyValueDisplay: React.FC<KeyValueDisplayProps> = ({
  data,
  money,
}) => {
  const filteredData = Object.entries(data).filter(([key, value]) => {
console.log({key})
    if (money) return value !== "--"; // Only filter "--" when money formatting is applied
    return !banned.includes(value); // Apply full filtering for non-money values
  });

  return (
    <div className="flex flex-col max-w-[700px] gap-2">
      {filteredData.map(([key, value]) => (
        <div key={key} className="flex items-center gap-3 pb-2">
          <div className="first size-3 rounded-full bg-themeColor"></div>
          <div className="flex gap-2">
            <span className="font-semibold whitespace-nowrap">{key}:</span>
            <span className="flex-1 capitalize ">{value}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

const propertyDetails: Record<string, string | number> = {
  "Property Title": "Obolongo Estate",
  Category: "Residential",
  Unit: "Unit 3 Bedroom, 1 Unit Self Contained With Penthouse",
  Document: "C of O, Record Copy, Survey, Agreement",
  "Source/Owner": "Ibrahim Matthew",
  "Total Area": "4354sqm",
  Offer: 21,
  "Total Views": 121,
  Bookmarks: 21,
  "Added Date": "21/01/2025",
  "Last Updated": "21/01/2025",
};

export const propertyDetails2: Record<string, string | number> = {
  "Property Title": "Obolongo Estate",
  "Discount Name": "Ileya Festival Promo",
  "Unit Preference": "Newly Built",
  "Discount Rate": "30%",
  Document: "C of O, Record Copy, Survey, Agreement",
  "Unit Type": 21,
  Bedroom: 21,
  Bathroom: 21,
  "Unit Name/Number": 21,
  "Total Unit": 21,
  "Available Unit": 43,
  "Total Area": "4354sqm",
  "Total Views": 121,
  Bookmarks: 21,
  "Added Date": "21/01/2025",
  "Last Updated": "21/01/2025",
};

// const initialPaymentDetails: Record<string, number> = {
//   "Inspection Fee": 3000000,
//   "Rent Fee": 3000000,
//   "Service Charge": 3000000,
//   "Refundable Caution Fee": 3000000,
//   "Non-Refundable Legal Fee": 3000000,
//   "Non-Refundable Agency Fee": 3000000,
//   "Other Fee": 3000000,
//   "Total Package": 3000000,
// };

// const renewalTenantDetails: Record<string, number> = {
//   "Rent Fee": 3000000,
//   "Service Charge": 3000000,
//   "Other Fee": 3000000,
//   "Total Package": 3000000,
// };

const firstDeposit: Record<string, string | number> = {
  "6 Months Plan": 3000000,
  "12 Months Plan": 3000000,
  "24 Months Plan": 3000000,
  "48 Months Plan": 3000000,
};

const monthlySpreading: Record<string, string | number> = {
  "6 Months Plan": 3000000,
  "12 Months Plan": 3000000,
  "24 Months Plan": 3000000,
  "48 Months Plan": 3000000,
};

const otherCharges: Record<string, string | number> = {
  Documents: 3000000,
  "Survey Fee": 3000000,
  "Development Fee": 3000000,
  "Other Fee": 3000000,
};

const priceDetails: Record<string, number> = {
  "Property Price": 3000000,
  "Agency Fee": 3000000,
  "Inspection Fee": 3000000,
  "Other Fee": 3000000,
};

export const StaffContact2: React.FC<MemberType> = ({
  name,
  role,
  phone,
  image,
  email,
  id,
  is_verified,
}) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const fullUrl =
    typeof window !== "undefined"
      ? `${window.location.origin}${pathname}?${searchParams.toString()}`
      : "";
  const cleanPhone = phone.replace(/\D/g, "");
  const slug = generateSlugWithId(id, name);
  return (
    <div className="flex flex-col items-start gap-2">
      <div className="flex w-full items-center gap-6">
        <Image
          height={96}
          width={96}
          src={image || "no image"}
          className="image block size-[6rem] rounded-xl"
          alt={name}
        />
        <div className="roles">
          <div className="flex justify-center items-center gap-2">
            <Link
              href={`/staff/${slug}`}
              className="text-secondary-main hover:underline h5 !font-semibold"
            >
              {capitalizeWords(name)}
            </Link>
            <VerifiedBadge verified={is_verified as boolean} />
          </div>

          <h6 className="text-themeColor">{role}</h6>
        </div>
      </div>

      <div className="flex flex-wrap gap-5">
        {phone && (
          <Link
            href={`tel:${phone}`}
            className="flex hover:underline whitespace-nowrap gap-2 items-center"
          >
            <CallIcon /> {phone}
          </Link>
        )}

        {phone && (
          <Link
            href={`https://wa.me/${cleanPhone}?text=Hello, I will like to enquire about this property on your website. ${fullUrl}`}
            className="flex gap-2 whitespace-nowrap hover:underline items-center"
          >
            <WhatsAppIcon /> Contact on WhatsApp
          </Link>
        )}
        {email && (
          <Link
            href={`mailto:${email}`}
            className="flex hover:underline gap-2 items-center"
          >
            <MessageIcon /> {email}
          </Link>
        )}
      </div>

      {/* 
      <Button className="w-full !block !py-4 mt-8">Contact</Button> */}
    </div>
  );
};

export const MessageIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6673 5.02344V11.3334C14.6673 11.8436 14.4724 12.3344 14.1225 12.7056C13.7725 13.0768 13.2939 13.3002 12.7847 13.3301L12.6673 13.3334H3.33398C2.82384 13.3335 2.33297 13.1386 1.96181 12.7886C1.59065 12.4386 1.36725 11.96 1.33732 11.4508L1.33398 11.3334V5.02344L7.63065 9.22144L7.70798 9.26544C7.79912 9.30997 7.89922 9.33311 8.00065 9.33311C8.10208 9.33311 8.20218 9.30997 8.29332 9.26544L8.37065 9.22144L14.6673 5.02344Z"
        fill="var(--primary-color)"
      />
      <path
        d="M12.6675 2.66797C13.3875 2.66797 14.0189 3.04797 14.3709 3.6193L8.00086 7.86597L1.63086 3.6193C1.79805 3.34785 2.02772 3.1203 2.30071 2.95563C2.5737 2.79095 2.88209 2.69393 3.20019 2.67264L3.33419 2.66797H12.6675Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};

export const CallIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.034 15.2569C10.074 15.2216 7.35335 14.8456 4.50402 11.9969C1.65535 9.14761 1.28002 6.42761 1.24402 5.46694C1.19068 4.00294 2.31202 2.58094 3.60735 2.02561C3.76333 1.95825 3.93415 1.93261 4.10304 1.95119C4.27192 1.96978 4.43308 2.03195 4.57068 2.13161C5.63735 2.90894 6.37335 4.08494 7.00535 5.00961C7.1444 5.21276 7.20386 5.45997 7.17239 5.70414C7.14091 5.94831 7.02071 6.17236 6.83468 6.33361L5.53402 7.29961C5.47118 7.34499 5.42694 7.41163 5.40953 7.48716C5.39212 7.56269 5.40272 7.64197 5.43935 7.71028C5.73402 8.24561 6.25802 9.04294 6.85802 9.64294C7.45802 10.2429 8.29335 10.8016 8.86602 11.1296C8.93782 11.1699 9.02233 11.1812 9.10219 11.1611C9.18204 11.141 9.25116 11.0911 9.29535 11.0216L10.142 9.73294C10.2977 9.52617 10.5273 9.38765 10.7828 9.3464C11.0383 9.30514 11.2999 9.36434 11.5127 9.51161C12.4507 10.1609 13.5453 10.8843 14.3467 11.9103C14.4544 12.0489 14.523 12.2139 14.5451 12.388C14.5673 12.5622 14.5423 12.7391 14.4727 12.9003C13.9147 14.2023 12.5027 15.3109 11.034 15.2569Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};

interface AccordionProps {
  data: {
    questions: { question: string; answer: string }[];
  };
}
export const AccordionVariant: React.FC<AccordionProps> = ({ data }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <div className="w-full rounded-2xl">
      {data.questions.map((item, index) => (
        <div key={index} className=" py-2 last:border-none">
          <button
            onClick={() => toggleAccordion(index)}
            className="w-full text-left transition-all text-secondary-main duration-500 flex justify-between items-center"
          >
            <div className="question flex items-center gap-2">
              <div className="rounded-full bg-themeColor size-3"></div>
              {item.question}
            </div>

            <span
              className={`text-themeColor  transform transition-all duration-200 text-2xl ${
                index === openIndex ? "rotate-[180deg]" : "rotate-0"
              }`}
            >
              <Angle />
            </span>
          </button>
          <LazyMotion features={domAnimation}>
            <AnimatePresence>
              {openIndex === index && (
                <m.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  transition={{
                    duration: 0.2,
                    ease: "easeInOut",
                  }}
                  exit={{ opacity: 0, height: 0 }}
                  className="pl-4 text-secondary-main"
                >
                  {item.answer}
                </m.div>
              )}
            </AnimatePresence>
          </LazyMotion>
        </div>
      ))}
    </div>
  );
};

export const Angle = () => {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2551_61445)">
        <path
          d="M3.68725 5.27266C3.59178 5.18244 3.47947 5.11191 3.35674 5.06509C3.23401 5.01828 3.10327 4.99609 2.97196 4.99981C2.84066 5.00352 2.71138 5.03306 2.59149 5.08674C2.47161 5.14042 2.36347 5.21719 2.27325 5.31266C2.18303 5.40813 2.1125 5.52044 2.06569 5.64316C2.01887 5.76589 1.99669 5.89664 2.0004 6.02794C2.00411 6.15924 2.03365 6.28853 2.08733 6.40841C2.14101 6.5283 2.21778 6.63644 2.31325 6.72666L11.3132 15.2267C11.4989 15.4022 11.7447 15.5 12.0002 15.5C12.2558 15.5 12.5016 15.4022 12.6872 15.2267L21.6882 6.72666C21.7858 6.63704 21.8646 6.52892 21.92 6.40859C21.9754 6.28827 22.0064 6.15813 22.0111 6.02573C22.0158 5.89334 21.9942 5.76133 21.9474 5.63737C21.9007 5.51341 21.8298 5.39998 21.7388 5.30366C21.6479 5.20734 21.5387 5.13005 21.4176 5.07629C21.2965 5.02252 21.166 4.99335 21.0335 4.99046C20.9011 4.98758 20.7694 5.01104 20.6461 5.05948C20.5228 5.10793 20.4103 5.18039 20.3153 5.27266L12.0002 13.1247L3.68725 5.27266Z"
          fill="var(--primary-color)"
        />
      </g>
      <defs>
        <clipPath id="clip0_2551_61445">
          <rect
            width="18"
            height="24"
            fill="white"
            transform="matrix(0 -1 1 0 0 18)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const WhatsAppIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9446 3.23867C10.8546 -0.00132513 6.57458 -0.961325 3.26458 1.04868C0.0345812 3.05868 -1.00542 7.43868 1.08458 10.6687L1.25458 10.9287L0.554581 13.5487L3.17458 12.8487L3.43458 13.0187C4.56458 13.6287 5.79458 13.9787 7.01458 13.9787C8.32458 13.9787 9.63458 13.6287 10.7646 12.9287C13.9946 10.8287 14.9546 6.53867 12.9446 3.21867V3.23867ZM11.1146 9.97867C10.7646 10.4987 10.3246 10.8487 9.71458 10.9387C9.36458 10.9387 8.92458 11.1087 7.18458 10.4187C5.70458 9.71868 4.47458 8.57868 3.60458 7.26868C3.08458 6.65868 2.81458 5.86868 2.73458 5.07868C2.73458 4.37868 2.99458 3.76868 3.43458 3.32868C3.60458 3.15868 3.78458 3.06868 3.95458 3.06868H4.39458C4.56458 3.06868 4.74458 3.06868 4.83458 3.41868C5.00458 3.85868 5.44458 4.90868 5.44458 4.99868C5.53458 5.08868 5.49458 5.75868 5.09458 6.13868C4.87458 6.38868 4.83458 6.39868 4.92458 6.57868C5.27458 7.09868 5.71458 7.62868 6.14458 8.06868C6.66458 8.50868 7.19458 8.85868 7.80458 9.11868C7.97458 9.20868 8.15458 9.20868 8.24458 9.02868C8.33458 8.85868 8.76458 8.41868 8.94458 8.23868C9.11458 8.06868 9.20458 8.06867 9.38458 8.14867L10.7846 8.84868C10.9546 8.93868 11.1346 9.01867 11.2246 9.10868C11.3146 9.36867 11.3146 9.71867 11.1346 9.97867H11.1146Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
